<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';
    import translations from './translations';
    import { mediaCookiesAccepted } from '$lib/Stores/stores';
    import { base } from '$app/paths';

    // Utils
    import clsx from 'clsx';
    import { getCookiePreferences, setCookiePreferences } from '$lib/helper';
    import { getBorderRadius } from '$lib/global/helper/border-radius';

    // Types
    import type { Language } from '$lib/types/Language';

    export let campaignId = '';
    export let language: Language = 'de';
    export let bgColor = 'transparent';
    export let layout = DEFAULT_LAYOUT;

    const { isInFramedColumn, isInColumn } = layout;

    const handleAccept = () => {
        const cookies = getCookiePreferences(campaignId);

        const updatedCookies = Object.assign({}, cookies);
        updatedCookies.Media = true;

        setCookiePreferences(campaignId, updatedCookies);

        $mediaCookiesAccepted = true;
    };

    const videoBorderRadiusClass = getBorderRadius('video');
    const buttonBorderRadiusClass = getBorderRadius('button');
</script>

<div class="grid aspect-video items-center font-sans" style:background={bgColor}>
    <div
        class={clsx(
            'relative mx-auto aspect-video w-full max-w-[448px] bg-cover bg-no-repeat lg:max-w-[608px]',
            videoBorderRadiusClass,
            {
                'max-sm:rounded-none': !layout.isInFramedColumn,
                'w-[calc(100%+32px)] -translate-x-4 sm:w-full sm:translate-x-0':
                    !isInFramedColumn && isInColumn,
            },
        )}
        style="background-image: url('https://perspective.imgix.net/assets/app/wizardfactory/mediabg.jpg?auto=compress')"
    >
        <div
            class="absolute left-0 top-0 flex h-full w-full flex-col items-center justify-center text-white"
        >
            <div class="w-8 sm:w-12 md:w-20">
                <svg
                    width="100%"
                    viewBox="0 0 34 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g filter="url(#filter0_d)">
                        <circle
                            cx="17"
                            cy="16"
                            r="15"
                            fill="black"
                            fill-opacity="0.1"
                            stroke="white"
                            stroke-width="2"
                        />
                        <path
                            d="M14.5 19.1925V12.1155C14.5 11.271 15.4821 10.8068 16.1347 11.3428L20.5382 14.9599C21.0321 15.3656 21.0238 16.1241 20.5213 16.519L16.1178 19.9789C15.4617 20.4944 14.5 20.027 14.5 19.1925Z"
                            fill="white"
                        />
                    </g>
                    <defs>
                        <filter
                            id="filter0_d"
                            x="0"
                            y="0"
                            width="34"
                            height="34"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                        >
                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                            <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            />
                            <feOffset dy="1" />
                            <feGaussianBlur stdDeviation="0.5" />
                            <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            />
                            <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow"
                                result="shape"
                            />
                        </filter>
                    </defs>
                </svg>
            </div>
            <span class="mb-6 mt-4 px-4 text-sm">
                {translations[language].cta}
                <a href={`${base}/consent-policy`} class="text-white underline hover:text-gray-300"
                    >{translations[language].cookies}</a
                >
            </span>
            <button
                class={clsx(
                    't-4 flex h-10 items-center justify-center bg-blue-500 px-4 text-sm text-white hover:bg-blue-600',
                    buttonBorderRadiusClass,
                )}
                on:click={handleAccept}>{translations[language].accept}</button
            >
        </div>
    </div>
</div>
